import React from 'react';
import BaseSelect from './Select/BaseSelect';
import CreatableSelect from "./Select/Creatable";
import {map, intersectionBy, isArray} from 'lodash';


const getSelectedOptions = (options, values) =>
    intersectionBy(
        options,
        isArray(values)
            ? map(values, value => ({value}))
            : [{value: values}],
        'value'
    );

const FormSelect = ({value, options, ...props}) => (
    <React.Fragment>
        {props.creatable ? (
            <CreatableSelect
                value={getSelectedOptions(options, value)}
                options={options}
                {...props}
            />
        ) : (
            props.multiple ? (
                <BaseSelect
                    options={options}
                    {...props}
                />
            ) : (
                <BaseSelect
                    value={getSelectedOptions(options, value)}
                    options={options}
                    {...props}
                />
            )
        )}

    </React.Fragment>
);

export default FormSelect;
